import React from "react"

import {BREAKDOWN_ALL_VALUES} from "../../../../../gd-modules/tasks-view/core/@const"
import {FieldQuickFilterViewProps} from "../../../../render/quick-filter-view"

// const debug = "FieldTaskSystemStatus_GroupByView"
const debug = false

export default function FieldTaskSystemStatus_QuickFilterView(props: FieldQuickFilterViewProps) {

    debug && console.log(debug, 'render', props)

    let label = ''
    let icon = null

    switch (props.value) {
        case BREAKDOWN_ALL_VALUES:
            label = 'All statuses'
            break

        default:
            const option = props.field._getOption(props.value)
            if (option) {
                icon = <div className={Classes("group-icon m-r-10 ui5-color-box gd-scbg-{0}".f(gd.const.systemStatusColor[props.value]))}/>
                label = option.label
            } else {
                label = props.value
            }
    }

    const classes = Classes("ui5-group-by-view", props.className)

    return (
        <div className={classes}>
            {icon}
            <div className="name">{label}</div>
        </div>
    )


}